import axios from 'axios'
import { Notification, Loading } from 'element-ui'
import qs from 'qs'
// 可以跨域请求
axios.defaults.withCredentials = true
// 验证可用域名
axios.defaults.baseURL = ''
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.headers['Cache-Control'] = 'no-cache'
axios.defaults.headers['Pragma'] = 'no-cache'
// axios.defaults.validateStatus = (status: number): boolean => {
//   return status < 600
// }
interface Config {
  isLoading: boolean
  isMessage: boolean
  isForm: boolean
  isCheckLogin: boolean
}
interface CustomConfig {
  isLoading?: boolean
  isMessage?: boolean
}
interface FinalMyData {
  data: any
  config: Config
}

const ShowTips = (msg: string) => {
  // @ts-expect-error I see
  Notification.closeAll()
  Notification({
    title: '',
    message: msg,
    position: 'top-right',
    type: 'warning'
  })
}
/** 接口请求的默认配置 */
const defaultConfig: Config = {
  /** 是否显示loading */
  isLoading: false,
  /** 是否显示接口异常时的弹窗 */
  isMessage: true,
  /** 是否form表单提交 */
  isForm: false,
  /** 是否检查登录，false时，接口reject，不会自动调转登录页 */
  isCheckLogin: true
}

const formHeaders = { 'Content-Type': 'application/x-www-form-urlencoded' }

let globalLoadingInstance: any = null
axios.interceptors.response.use(
  function (response) {
    if (globalLoadingInstance) {
      globalLoadingInstance.close()
    }
    return response
  },
  function (error) {
    if (globalLoadingInstance) {
      globalLoadingInstance.close()
    }
    return Promise.reject(error)
  }
)
/** 跳转至SSO登录 */
let isDirecting = false
const redirectToLogin = async () => {
  if (isDirecting) {
    return isDirecting
  }
  isDirecting = true
  try {
    isDirecting = false
  } catch (error) {
    isDirecting = false
  }
  return isDirecting
}

// 返回异常处理
const responseReject = (config: Config, error: any) => {
  const res = error.data || {
    errNo: -1,
    errMsg: '您的网络异常，请确认网络环境后重试！'
  }
  const msg = error.msg || '您的网络异常，请确认网络环境后重试！'
  config.isMessage && ShowTips(msg)
  return Promise.reject(res)
}

function handleResponse(response: any, config: Config) {
  return new Promise((resolve, reject) => {
    let msg = ''
    if (response.status === 200) {
      const errCode: number | undefined = response.data.errNo
      if (errCode === 0) {
        return resolve(response.data)
      }
      msg = response.data.errMsg || '出问题了~请检查响应信息'
      if (config.isCheckLogin && (errCode === 3 || errCode === 99)) {
        // 登录失效，跳转登录
        setTimeout(redirectToLogin, 1000)
      }
      reject({ data: response.data, msg })
    } else {
      reject({ data: response.data, msg })
    }
  })
}
function _get(path: string, myData: FinalMyData): Promise<any> {
  return axios
    .get(path, {
      params: myData.data
    })
    .then((response: any): Promise<any> => {
      return handleResponse(response, myData.config)
    })
    .catch((error: any) => responseReject(myData.config, error))
}
function _post(path: string, myData: FinalMyData): Promise<any> {
  return axios
    .post(path, myData.data)
    .then((response: any): Promise<any> => {
      return handleResponse(response, myData.config)
    })
    .catch((error: any) => responseReject(myData.config, error))
}
// form 表单提交
function _form_post(path: string, myData: FinalMyData): Promise<any> {
  return axios
    .post(path, qs.stringify(myData.data), { headers: formHeaders })
    .then((response: any): Promise<any> => {
      return handleResponse(response, myData.config)
    })
    .catch((error: any) => responseReject(myData.config, error))
}
function _file(path: string, myData: FinalMyData): Promise<any> {
  return axios
    .post(path, myData.data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
    .then((response: any): Promise<any> => {
      return handleResponse(response, myData.config)
    })
    .catch((error: any) => responseReject(myData.config, error))
}

// 查找请求类型及地址
const factory = (obj: {
  [key: string]: any
}): { [key: string]: (...argv: object[]) => Promise<any> } => {
  const output: { [key: string]: any } = {}
  Object.keys(obj).forEach((methodKey) => {
    Object.keys(obj[methodKey]).forEach((apiKey) => {
      // 本地联调时,直接在访问地址中加上对应docker环境的ZYBUUAP值,有效期一天.失效后去
      const param = process.env.NODE_ENV === 'development' ? `` : ''
      const api: string = obj[methodKey][apiKey] + param
      output[apiKey] = (
        myData: any = {},
        myConfig: CustomConfig = {}
      ): Promise<any> => {
        const finalConfig: Config = Object.assign({}, defaultConfig, myConfig)
        const finalMyData: FinalMyData = {
          data: myData,
          config: finalConfig
        }
        if (finalMyData.config.isLoading) {
          globalLoadingInstance = Loading.service({})
        }

        switch (methodKey) {
          case 'get':
            return _get(api, finalMyData)
          case 'post':
            return finalConfig.isForm
              ? _form_post(api, finalMyData)
              : _post(api, finalMyData)
          case 'file':
            return _file(api, finalMyData)
          default:
            return Promise.resolve(null)
        }
      }
    })
  })
  return output
}
export default factory
